import axios from "axios";
import { clearActivity, touchActivity } from "utils/activity";
import { getRoleFromStorage } from "utils/auth";

const httpClient = axios.create({
  // In production behind Apache, keep this as "/api".
  // In dev you can set REACT_APP_API_URL="http://127.0.0.1:5000/api"
  baseURL: process.env.REACT_APP_API_URL || "/api",
  withCredentials: false,
});

httpClient.interceptors.request.use((config) => {
  touchActivity();

  const saved = localStorage.getItem("auth");
  if (saved) {
    try {
      const parsed = JSON.parse(saved);
      const token = parsed?.token;
      if (token) {
        config.headers = config.headers ?? {};
        config.headers.Authorization = `Bearer ${token}`;
      }
    } catch {
      // ignore
    }
  }

  return config;
});

httpClient.interceptors.response.use(
  (res) => res,
  async (err) => {
    if (!err.response) return Promise.reject(err);

    const status = err.response.status;

    // If token is invalid/expired, clear session and redirect to login.
    if (status === 401) {
      clearActivity();
      role = getRoleFromStorage();
      localStorage.removeItem("auth");
      if (role === "AGENT") {
        window.location.href = "/authentication/agent-sign-in";
      } else {
        window.location.href = "/authentication/sign-in";
      }
    }

    return Promise.reject(err);
  }
);

export default httpClient;
